<template>
    <div>
        <div class="banner" data-aos="zoom-out"><img :src="require('@/assets/img/about/contact/bj.jpg')" ></div>
        <div class="service">
            <div class="title" data-aos="fade-up">服务中心</div>
            <div class="number"  data-aos="fade-up">2026</div>
            <div class="content"  data-aos="fade-up">
                上海唐顾信息技术有限公司拥有成熟的服务团队，快速相应客户需求，<br>遍布全国的销售与服务网络，更能带给您及时的咨询反馈与方案信息等，期待与您的沟通与合作!
            </div>
            <div class="serviceLine">
                <div class="item aos-animate" :data-aos="index<=5?'fade-right':'fade-left'" v-for="item,index in serviceLine" :style="{left:(index+1)*103+'px'}">
                    <div></div>
                    <div v-html="item"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <about-menu @aboutSelect="aboutSelect"></about-menu>
            <div>
                <div class="phone">
                    <div class="phoneLeft">
                        <div data-aos="fade-right">
                            联系方式
<!--                            <div class="content">-->
<!--                                <div class="title"><span>—</span><span>联系方式</span><span>—</span></div>-->
<!--                                <div class="list" v-for="item,index in phone.contact">-->
<!--                                    <div class="listTitle">{{item.title}}</div>-->
<!--                                    <div class="listContent" v-for="list in item.list" :style="{'justify-content':index===0?'start':'space-between'}">-->
<!--                                        <div v-show="index>0">{{list.address}}</div>-->
<!--                                        <div :style="{'padding':index===0?'0 12px 0 0':'0 6px'}">{{list.name}}</div>-->
<!--                                        <div>{{list.phone}}</div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                        <div data-aos="fade-down">
                            售前咨询
                            <div class="content">
                                <div class="title"><span>—</span><span>售前咨询</span><span>—</span></div>
                                <div class="list" v-for="(item,index) in phone.preSale">
                                    <div class="listTitle">{{item.title}}</div>
                                    <div class="listContent" v-for="list in item.list" :style="{'justify-content':index===0?'start':'space-between'}">
<!--                                        <div v-show="index>0">{{list.address}}</div>-->
<!--                                        <div :style="{'padding':index===0?'0 12px 0 0':'0 6px'}">{{list.name}}</div>-->
                                        <div>{{list.phone}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                          <div style="      color: #0658a7;">售后服务</div>

<!--                            <div class="content">-->
<!--                                <div class="title"><span>—</span><span>售后服务</span><span>—</span></div>-->
<!--                                <div style="display: flex">-->
<!--                                 <div><img src="../../assets/img/qrCode1.png" style="height: 140px" /></div>-->
<!--                                 <div style="color: white;font-size: 20px;text-align: left;padding-left: 20px;margin-top: 15px">微信扫描左侧"售后工单",填写问题描述,将会有专人联系您并提供售后服务。-->
<!--                                   <br/> <br/>-->
<!--                                   售后热线   021-60936903-->
<!--                                 </div>-->
<!--                                </div>-->
<!--&lt;!&ndash;                                <div class="list" v-for="item,index in phone.afterSales">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="listTitle">{{item.title}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="listContent" v-for="list in item.list" :style="{'justify-content':index===0?'start':'space-between'}">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div v-show="index>0">{{list.address}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div :style="{'padding':index===0?'0 12px 0 0':'0 6px'}">{{list.name}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div>{{list.phone}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="phoneRight1" data-aos="fade-left">
                        大区销售
<!--                        <div class="content">-->
<!--                            <div class="title"><span>—</span><span>大区销售</span><span>—</span></div>-->
<!--                            <div class="list">-->
<!--&lt;!&ndash;                              <div class="listContent">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div>运营总经理</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div style="padding:0 6px">秦轶鹏</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div>18217291131</div>&ndash;&gt;-->
<!--&lt;!&ndash;                              </div>&ndash;&gt;-->
<!--                              <div class="listContent">-->
<!--                                <div>副总经理&nbsp;&nbsp;&nbsp;</div>-->
<!--                                <div style="padding:0 6px">卞国庆</div>-->
<!--                                <div>15212421161</div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                            <div class="list" v-for="(item,index) in phone.sell">-->
<!--                                <div class="listTitle">{{item.title}}</div>-->
<!--                                <div class="listContent" v-for="(list,key) in item.list" :style="{'justify-content':index===0?'start':'space-between'}">-->
<!--                                    <div>{{list.address}} — &nbsp;</div>-->
<!--                                    <div :style="{'padding':index===0?'0 12px 0 0':'0 6px'}">{{list.name}}</div>-->
<!--                                    <div>{{list.phone}}</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
                <div class="map">
                    <div class="title" data-aos="fade-up">公司地址</div>
                    <div class="content" data-aos="zoom-in" v-for="item in map" >
                        <img :src="item.src" alt="">
                        <div>
                            <span>{{item.title}}</span>
                            <span>{{item.address}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WOW from '../../../node_modules/wowjs/dist/wow';
import AboutMenu from "../../components/AboutMenu";
export default {
	components: {
        AboutMenu
    },
	data() {
		return {
            serviceLine:[
                '上海-总部',
                // '湖州<br>研发中心',
                // '无锡<br>分公司',
                '北京',
                '沈阳',
                '西安',
                '郑州',
                '武汉',
                '成都',
                '合肥',
                '湖州',
                '杭州',
                '广州',
            ],
            phone:{
                // contact:[
                //     {
                //         title:'- 全国区域销售总监',
                //         list:[
                //             {
                //               address:'',
                //               name:'秦轶鹏',
                //               phone:'18217291131'
                //             }
                //         ]
                //     },
                // ],
                preSale:[
                    {
                        title:'- 联系方式（工作日 9:00-17:00）',
                        list:[
                            {
                            address:'',
                            name:'',
                            phone:'021-60936903'
                          }
                        ]
                    },
                ],
                afterSales:[
                    {
                        title:'- 联系方式',
                        list:[
                            {
                              address:'',
                              name:'',
                              phone:'021-60936903'
                            }
                        ]
                    },
                ],
                sell:[
                    // {
                    //     title:'- 全国区域销售总监',
                    //     list:[
                    //         {
                    //           address:'',
                    //           name:'秦轶鹏',
                    //           phone:'18217291131'
                    //         }
                    //     ]
                    // },
                    {
                        title:'- 各区域销售总监/经理',
                        list:[
                            // {
                            //   address:'华中大区',
                            //   name:'卞国庆',
                            //   phone:'15212421161'
                            // },
                            {
                              address:'华北地区',
                              name:'殷朝晖',
                              phone:'13801103558'
                            },
                            {
                              address:'东北地区',
                              name:'王云鹏',
                              phone:'13802510414'
                            },
                            {
                              address:'西北地区',
                              name:'李由',
                              phone:'13201802020'
                            },
                            {
                              address:'华东地区',
                              name:'韩佳希',
                              phone:'18101885558'
                            },
                            {
                              address:'西南地区',
                              name:'何杰',
                              phone:'13981934006'
                            },
                            {
                              address:'华南地区',
                              name:'刘倩',
                              phone:'18998385211'
                            },
                        ]
                    }
                ]
            },
            map:[
                {
                    title:'上海总部',
                    address:'上海市张衡路666弄1号楼',
                    src:require('@/assets/img/about/contact/map1.jpg')
                },
                // {
                //     title:'无锡分部',
                //     address:'江苏省无锡市滨湖区马山梅梁西路88号',
                //     src:require('@/assets/img/about/contact/map2.png')
                // },
                // {
                //     title:'湖州研发中心',
                //     address:'浙江省湖州市吴兴区二环西路2077号港隆大厦812室',
                //     src:require('@/assets/img/about/contact/map3.jpg')
                // },
            ]
        }
	},
	mounted() {
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
    },
    methods:{
        aboutSelect(src){
	        this.$emit('aboutSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .banner{
        img{
            width: 100%;
        }
    }
    .service{
        width: 100%;
        height: 776px;
        margin-top: -3.5px;
        background: url("../../assets/img/about/contact/serviceBg.png") no-repeat;
        padding-top: 76px;
        box-sizing: border-box;
        .title{
            width: 347px;
            height: 66px;
            margin: 0 auto;
            background: url("../../assets/img/about/contact/serverTitle.png") no-repeat;
            color: #fff;
            font-size: 32px;
            text-align: center;
            letter-spacing: 15px;
        }
        .number{
            margin: 80px auto 0px;
            font-size: 150px;
            text-align: center;
            color: #fff;
            font-family: "E";
            letter-spacing: 18px;
        }
        .content{
            color: #fff;
            text-align: center;
            font-size: 15px;
            line-height: 30px;
            letter-spacing: 2px;
        }
        .serviceLine{
            width: 1310px;
            height: 1px;
            position: relative;
            background: #fff;
            margin: 177px auto 0;
            box-sizing: border-box;
            .item{
                top: -10px;
                position: absolute;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                div:nth-child(1){
                    width: 23px;
                    height: 23px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    border: 1px solid #dedede;
                    background: #fff;
                }
                div:nth-child(2){
                    width: 100%;
                    text-align: center;
                    margin-top: 10px;
                    line-height: 20px;
                    color: #fff;
                    font-size: 15px;
                }
            }
            .item:nth-child(1){
                div:nth-child(1){
                    background: #ed1c24;
                }
            }
        }
    }
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .phone{
        width: 1199px;
        height: 540px;
        margin: 130px auto 0;
        display: flex;
        justify-content: space-between;
        .phoneLeft{
            width: 824px;
            height: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            &>div{
                text-align: center;
                line-height: 283px;
                position: relative;
                color: #0658a7;
                font-size: 29px;
                font-weight: 500;
                letter-spacing: 8px;
            }
            &>div:nth-child(1){
                width: 524px;
                height: 283px;
                line-height: 283px;
                background: url("../../assets/img/about/contact/phoneBg1.png");
            }
            &>div:nth-child(2){
                width: 288px;
                height: 283px;
                line-height: 283px;
                background: url("../../assets/img/about/contact/phoneBg2.png");
                .content{
                    padding: 60px 16px!important;
                }
            }
            &>div:nth-child(3){
                width: 824px;
                height: 225px;
                line-height: 225px;
                background: url("../../assets/img/about/contact/phoneBg3.png");
                .content{
                    padding: 30px 16px!important;
                }
            }
            .content{
                display: none;
                width: 100%;
                height: 100%;
                padding: 60px 34px;
                position: absolute;
                top: 0;
                left: 0;
                background: rgba(13,115,251,0.8);
                box-sizing: border-box;
                line-height: normal;
                .title{
                    color: #fff;
                    display: flex;
                    justify-content: space-between;
                    span{
                        color: #fff;
                    }
                }
                .list{
                    font-size: 17px;
                    text-align: left;
                    margin-top: 40px;
                    div{
                        color: #fff;
                        letter-spacing: 0;
                        line-height: 32px;
                    }
                    .listContent{
                        display: flex;
                        justify-content: space-between;
                        padding-left: 12px;
                        &>div:nth-child(2){
                            width: 66px;
                            padding: 0px 6px;
                            box-sizing: border-box;
                            text-align: justify;
                            text-align-last: justify;
                        }
                    }
                }
            }
            &>div:hover{
                color: rgba(0,0,0,0);
                .content{
                    display: block;
                }
            }
            &>div:nth-child(1):hover{
                color: #0658a7;
            }
        }
        .phoneRight{
            width: 363px;
            height: 520px;
            line-height: 520px;
            color: #0658a7;
            font-size: 29px;
            font-weight: 500;
            letter-spacing: 8px;
            text-align: center;
            background: url("../../assets/img/about/contact/phoneBg4.png");
            position: relative;
            .content{
                display: none;
                width: 100%;
                height: 100%;
                padding: 60px 34px;
                position: absolute;
                top: 0;
                left: 0;
                background: rgba(13,115,251,0.8);
                box-sizing: border-box;
                line-height: normal;
                .title{
                    color: #fff;
                    display: flex;
                    justify-content: space-between;
                    span{
                        color: #fff;
                    }
                }
                .list{
                    font-size: 17px;
                    text-align: left;
                    margin-top: 40px;
                    div{
                        color: #fff;
                        letter-spacing: 0;
                        line-height: 32px;
                    }
                    .listContent{
                        display: flex;
                        justify-content: space-between;
                        padding-left: 12px;
                        &>div:nth-child(2){
                            width: 66px;
                            padding: 0px 6px;
                            box-sizing: border-box;
                            text-align: justify;
                            text-align-last: justify;
                        }
                    }
                }
            }
            &:hover{
                color: rgba(0,0,0,0);
                .content{
                    display: block;
                }
            }
        }
      .phoneRight1{
        width: 363px;
        height: 520px;
        line-height: 520px;
        color: #0658a7;
        font-size: 29px;
        font-weight: 500;
        letter-spacing: 8px;
        text-align: center;
        background: url("../../assets/img/about/contact/phoneBg4.png");
        position: relative;
        .content{
          display: none;
          width: 100%;
          height: 100%;
          padding: 60px 34px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(13,115,251,0.8);
          box-sizing: border-box;
          line-height: normal;
          .title{
            color: #fff;
            display: flex;
            justify-content: space-between;
            span{
              color: #fff;
            }
          }
          .list{
            font-size: 17px;
            text-align: left;
            margin-top: 40px;
            div{
              color: #fff;
              letter-spacing: 0;
              line-height: 32px;
            }
            .listContent{
              display: flex;
              justify-content: space-between;
              padding-left: 12px;
              &>div:nth-child(2){
                width: 66px;
                padding: 0px 6px;
                box-sizing: border-box;
                text-align: justify;
                text-align-last: justify;
              }
            }
          }
        }
      }
    }
    .map{
        margin-top: 74px;
        .title{
            text-align: center;
            font-size: 32px;
            line-height: 32px;
            height: 66px;
            color: #ed1c24;
            background: url("../../assets/img/about/contact/mapTitle.png") no-repeat center;
            letter-spacing: 16px;
        }
        .content{
            width: 1180px;
            margin: 80px auto;
            box-sizing: border-box;
            padding: 30px 35px 20px;
            box-shadow: 0 2px  10px #dedede;
            img{
                width: 100%;
                height: 100%;
            }
            div{
                width: 100%;
                text-align: right;
                margin-top: 20px;
                font-size: 16px;
                span:nth-child(1){
                    display: inline-block;
                    height: 21px;
                    padding: 0 20px;
                    line-height: 21px;
                    background: #ed1c24;
                    font-size: 15px;
                    color: #fff;
                    letter-spacing: 2px;
                    text-align: center;
                    border-radius: 5px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
